module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/client/client-edit/client-edit.component.css
// module id = ./src/app/components/client/client-edit/client-edit.component.css
// module chunks = main